import { render, staticRenderFns } from "./about-us-news.vue?vue&type=template&id=137d4283&scoped=true&"
import script from "./about-us-news.vue?vue&type=script&lang=js&"
export * from "./about-us-news.vue?vue&type=script&lang=js&"
import style0 from "./about-us-news.vue?vue&type=style&index=0&id=137d4283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d4283",
  null
  
)

export default component.exports